module.exports = __webpack_public_path__ + "static/media/mass_button_icon.9d8874be.svg";